import { Contact, Account, Lead, Case, Task, Opportunity } from '../../types'

const now = new Date()
const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
const twoWeeksAgo = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000)
const oneMonthAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000)

export const mockAccounts: Account[] = [
  {
    id: 'acc-001',
    name: 'Acme Corporation',
    industry: 'Technology',
    website: 'acme.com',
    phone: '+1-555-0100',
    owner: 'Sarah Johnson',
    description: 'Leading enterprise software solutions provider',
    createdAt: oneMonthAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'acc-002',
    name: 'GlobalTech Solutions',
    industry: 'Consulting',
    website: 'globaltech.io',
    phone: '+1-555-0101',
    owner: 'Michael Chen',
    description: 'Digital transformation consulting firm',
    createdAt: oneMonthAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'acc-003',
    name: 'CloudFirst Industries',
    industry: 'Cloud Services',
    website: 'cloudfirst.com',
    phone: '+1-555-0102',
    owner: 'Emily Rodriguez',
    description: 'Cloud infrastructure and managed services',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'acc-004',
    name: 'DataViz Analytics',
    industry: 'Analytics',
    website: 'dataviz.ai',
    phone: '+1-555-0103',
    owner: 'James Wilson',
    description: 'Business intelligence and analytics platform',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'acc-005',
    name: 'SecureNet Systems',
    industry: 'Cybersecurity',
    website: 'securenet.com',
    phone: '+1-555-0104',
    owner: 'Patricia Lee',
    description: 'Enterprise cybersecurity solutions',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
]

export const mockContacts: Contact[] = [
  {
    id: 'con-001',
    firstName: 'John',
    lastName: 'Smith',
    salutation: 'Mr.',
    email: 'john.smith@acme.com',
    phone: '+1-555-1001',
    title: 'VP Engineering',
    accountId: 'acc-001',
    accountName: 'Acme Corporation',
    owner: 'Sarah Johnson',
    createdAt: oneMonthAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'con-002',
    firstName: 'Amanda',
    lastName: 'White',
    salutation: 'Mrs.',
    email: 'amanda.white@acme.com',
    phone: '+1-555-1002',
    title: 'CFO',
    accountId: 'acc-001',
    accountName: 'Acme Corporation',
    owner: 'Sarah Johnson',
    createdAt: oneMonthAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'con-003',
    firstName: 'David',
    lastName: 'Brown',
    salutation: 'Mr.',
    email: 'david.brown@globaltech.io',
    phone: '+1-555-1003',
    title: 'Director of Sales',
    accountId: 'acc-002',
    accountName: 'GlobalTech Solutions',
    owner: 'Michael Chen',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'con-004',
    firstName: 'Lisa',
    lastName: 'Martinez',
    salutation: 'Ms.',
    email: 'lisa.martinez@cloudfirst.com',
    phone: '+1-555-1004',
    title: 'Account Manager',
    accountId: 'acc-003',
    accountName: 'CloudFirst Industries',
    owner: 'Emily Rodriguez',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'con-005',
    firstName: 'Robert',
    lastName: 'Johnson',
    salutation: 'Dr.',
    email: 'robert.johnson@dataviz.ai',
    phone: '+1-555-1005',
    title: 'CTO',
    accountId: 'acc-004',
    accountName: 'DataViz Analytics',
    owner: 'James Wilson',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'con-006',
    firstName: 'Jennifer',
    lastName: 'Taylor',
    salutation: 'Ms.',
    email: 'jennifer.taylor@securenet.com',
    phone: '+1-555-1006',
    title: 'Security Officer',
    accountId: 'acc-005',
    accountName: 'SecureNet Systems',
    owner: 'Patricia Lee',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'con-007',
    firstName: 'Michael',
    lastName: 'Anderson',
    salutation: 'Mr.',
    email: 'michael.anderson@acme.com',
    phone: '+1-555-1007',
    title: 'Product Manager',
    accountId: 'acc-001',
    accountName: 'Acme Corporation',
    owner: 'Sarah Johnson',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'con-008',
    firstName: 'Sarah',
    lastName: 'Davis',
    salutation: 'Ms.',
    email: 'sarah.davis@globaltech.io',
    phone: '+1-555-1008',
    title: 'Consultant',
    accountId: 'acc-002',
    accountName: 'GlobalTech Solutions',
    owner: 'Michael Chen',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'con-009',
    firstName: 'Thomas',
    lastName: 'Wilson',
    salutation: 'Mr.',
    email: 'thomas.wilson@cloudfirst.com',
    phone: '+1-555-1009',
    title: 'System Administrator',
    accountId: 'acc-003',
    accountName: 'CloudFirst Industries',
    owner: 'Emily Rodriguez',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'con-010',
    firstName: 'Catherine',
    lastName: 'Garcia',
    salutation: 'Ms.',
    email: 'catherine.garcia@dataviz.ai',
    phone: '+1-555-1010',
    title: 'Business Analyst',
    accountId: 'acc-004',
    accountName: 'DataViz Analytics',
    owner: 'James Wilson',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
]

export const mockLeads: Lead[] = [
  {
    id: 'lead-001',
    firstName: 'Kevin',
    lastName: 'O\'Brien',
    email: 'kevin.obrien@example.com',
    phone: '+1-555-2001',
    company: 'InnovateTech',
    title: 'CEO',
    status: 'Nuevo',
    owner: 'Sarah Johnson',
    description: 'Interested in enterprise solutions',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'lead-002',
    firstName: 'Nicole',
    lastName: 'Thompson',
    email: 'nicole.thompson@startup.io',
    phone: '+1-555-2002',
    company: 'StartupHub',
    title: 'Product Director',
    status: 'Contactado',
    owner: 'Michael Chen',
    description: 'Qualified prospect for consulting services',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'lead-003',
    firstName: 'Christopher',
    lastName: 'Evans',
    email: 'chris.evans@midmarket.com',
    phone: '+1-555-2003',
    company: 'MidMarket Inc',
    title: 'CFO',
    status: 'Nurturing',
    owner: 'Emily Rodriguez',
    description: 'In evaluation phase',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: oneWeekAgo.toISOString(),
  },
  {
    id: 'lead-004',
    firstName: 'Rachel',
    lastName: 'Murphy',
    email: 'rachel.murphy@enterprise.org',
    phone: '+1-555-2004',
    company: 'EnterpriseGlobal',
    title: 'VP Operations',
    status: 'No cualificado',
    owner: 'James Wilson',
    description: 'Budget constraints',
    createdAt: oneMonthAgo.toISOString(),
    updatedAt: oneWeekAgo.toISOString(),
  },
  {
    id: 'lead-005',
    firstName: 'Mark',
    lastName: 'Bennett',
    email: 'mark.bennett@growth.co',
    phone: '+1-555-2005',
    company: 'GrowthPartners',
    title: 'Chief Commercial Officer',
    status: 'Converted',
    owner: 'Patricia Lee',
    description: 'Successfully converted to opportunity',
    createdAt: oneMonthAgo.toISOString(),
    updatedAt: twoWeeksAgo.toISOString(),
  },
  {
    id: 'lead-006',
    firstName: 'Amanda',
    lastName: 'Chen',
    email: 'amanda.chen@future.tech',
    phone: '+1-555-2006',
    company: 'FutureTech Ventures',
    title: 'Founder',
    status: 'Nuevo',
    owner: 'Sarah Johnson',
    description: 'Series A funded startup',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'lead-007',
    firstName: 'Brandon',
    lastName: 'Scott',
    email: 'brandon.scott@corp.com',
    phone: '+1-555-2007',
    company: 'CorporateShift',
    title: 'IT Director',
    status: 'Contactado',
    owner: 'Michael Chen',
    description: 'Scheduled for demo next week',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'lead-008',
    firstName: 'Victoria',
    lastName: 'Harper',
    email: 'victoria.harper@retail.io',
    phone: '+1-555-2008',
    company: 'RetailMax',
    title: 'Director Digital',
    status: 'Nurturing',
    owner: 'Emily Rodriguez',
    description: 'Evaluating solutions',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: oneWeekAgo.toISOString(),
  },
]

export const mockCases: Case[] = [
  {
    id: 'case-001',
    caseNumber: 'CS-00001',
    subject: 'Unable to login to platform',
    status: 'Working',
    origin: 'Email',
    priority: 'High',
    contactId: 'con-001',
    contactName: 'John Smith',
    accountId: 'acc-001',
    accountName: 'Acme Corporation',
    owner: 'Sarah Johnson',
    description: 'User reports authentication failures',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: oneWeekAgo.toISOString(),
  },
  {
    id: 'case-002',
    caseNumber: 'CS-00002',
    subject: 'Data export issue',
    status: 'New',
    origin: 'Web',
    priority: 'Medium',
    contactId: 'con-003',
    contactName: 'David Brown',
    accountId: 'acc-002',
    accountName: 'GlobalTech Solutions',
    owner: 'Michael Chen',
    description: 'Export functionality not working properly',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'case-003',
    caseNumber: 'CS-00003',
    subject: 'Performance degradation',
    status: 'Escalated',
    origin: 'Teléfono',
    priority: 'High',
    contactId: 'con-004',
    contactName: 'Lisa Martinez',
    accountId: 'acc-003',
    accountName: 'CloudFirst Industries',
    owner: 'Emily Rodriguez',
    description: 'System running slow during peak hours',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: oneWeekAgo.toISOString(),
  },
  {
    id: 'case-004',
    caseNumber: 'CS-00004',
    subject: 'Integration setup assistance needed',
    status: 'Working',
    origin: 'Email',
    priority: 'Medium',
    contactId: 'con-005',
    contactName: 'Robert Johnson',
    accountId: 'acc-004',
    accountName: 'DataViz Analytics',
    owner: 'James Wilson',
    description: 'Help needed with API integration',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: oneWeekAgo.toISOString(),
  },
  {
    id: 'case-005',
    caseNumber: 'CS-00005',
    subject: 'Feature request for reporting',
    status: 'New',
    origin: 'Web',
    priority: 'Low',
    contactId: 'con-006',
    contactName: 'Jennifer Taylor',
    accountId: 'acc-005',
    accountName: 'SecureNet Systems',
    owner: 'Patricia Lee',
    description: 'Requesting new reporting capabilities',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
]

export const mockTasks: Task[] = [
  {
    id: 'task-001',
    subject: 'Follow up with Acme Corporation',
    status: 'In Progress',
    priority: 'High',
    dueDate: new Date(now.getTime() + 2 * 24 * 60 * 60 * 1000).toISOString(),
    assignedTo: 'Sarah Johnson',
    relatedToId: 'acc-001',
    relatedToType: 'Account',
    comments: 'Discuss Q2 budget allocation',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'task-002',
    subject: 'Send proposal to GlobalTech',
    status: 'Not Started',
    priority: 'High',
    dueDate: new Date(now.getTime() + 1 * 24 * 60 * 60 * 1000).toISOString(),
    assignedTo: 'Michael Chen',
    relatedToId: 'acc-002',
    relatedToType: 'Account',
    comments: 'Include pricing details',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: oneWeekAgo.toISOString(),
  },
  {
    id: 'task-003',
    subject: 'Call Lisa Martinez',
    status: 'Not Started',
    priority: 'Medium',
    dueDate: new Date(now.getTime() + 3 * 24 * 60 * 60 * 1000).toISOString(),
    assignedTo: 'Emily Rodriguez',
    contactId: 'con-004',
    contactName: 'Lisa Martinez',
    comments: 'Check implementation progress',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'task-004',
    subject: 'Review contract terms',
    status: 'In Progress',
    priority: 'High',
    dueDate: new Date(now.getTime() + 1 * 24 * 60 * 60 * 1000).toISOString(),
    assignedTo: 'James Wilson',
    relatedToId: 'acc-004',
    relatedToType: 'Account',
    comments: 'Legal review pending',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: oneWeekAgo.toISOString(),
  },
  {
    id: 'task-005',
    subject: 'Complete onboarding checklist',
    status: 'Completed',
    priority: 'Medium',
    dueDate: oneWeekAgo.toISOString(),
    assignedTo: 'Patricia Lee',
    relatedToId: 'acc-005',
    relatedToType: 'Account',
    comments: 'User training completed',
    createdAt: oneMonthAgo.toISOString(),
    updatedAt: twoWeeksAgo.toISOString(),
  },
]

export const mockOpportunities: Opportunity[] = [
  {
    id: 'opp-001',
    name: 'Enterprise License - Acme',
    accountId: 'acc-001',
    accountName: 'Acme Corporation',
    amount: 150000,
    stage: 'Negotiation',
    probability: 75,
    closeDate: new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    owner: 'Sarah Johnson',
    description: 'Full enterprise solution with support',
    createdAt: oneMonthAgo.toISOString(),
    updatedAt: oneWeekAgo.toISOString(),
  },
  {
    id: 'opp-002',
    name: 'Consulting Services - GlobalTech',
    accountId: 'acc-002',
    accountName: 'GlobalTech Solutions',
    amount: 75000,
    stage: 'Proposal',
    probability: 50,
    closeDate: new Date(now.getTime() + 45 * 24 * 60 * 60 * 1000).toISOString(),
    owner: 'Michael Chen',
    description: 'Digital transformation project',
    createdAt: twoWeeksAgo.toISOString(),
    updatedAt: oneWeekAgo.toISOString(),
  },
  {
    id: 'opp-003',
    name: 'Cloud Migration - CloudFirst',
    accountId: 'acc-003',
    accountName: 'CloudFirst Industries',
    amount: 250000,
    stage: 'Qualification',
    probability: 25,
    closeDate: new Date(now.getTime() + 60 * 24 * 60 * 60 * 1000).toISOString(),
    owner: 'Emily Rodriguez',
    description: 'Multi-phase cloud infrastructure migration',
    createdAt: oneWeekAgo.toISOString(),
    updatedAt: now.toISOString(),
  },
  {
    id: 'opp-004',
    name: 'Analytics Platform - DataViz',
    accountId: 'acc-004',
    accountName: 'DataViz Analytics',
    amount: 120000,
    stage: 'Closed Won',
    probability: 100,
    closeDate: twoWeeksAgo.toISOString(),
    owner: 'James Wilson',
    description: 'Custom analytics implementation',
    createdAt: oneMonthAgo.toISOString(),
    updatedAt: twoWeeksAgo.toISOString(),
  },
]
